var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.55556 14.4444H4.66389L12.2667 6.84167L11.1583 5.73333L3.55556 13.3361V14.4444ZM2 16V12.6944L12.2667 2.44722C12.4222 2.30463 12.594 2.19444 12.7819 2.11667C12.9699 2.03889 13.1676 2 13.375 2C13.5824 2 13.7833 2.03889 13.9778 2.11667C14.1722 2.19444 14.3407 2.31111 14.4833 2.46667L15.5528 3.55556C15.7083 3.69815 15.8218 3.86667 15.8931 4.06111C15.9644 4.25556 16 4.45 16 4.64444C16 4.85185 15.9644 5.04954 15.8931 5.2375C15.8218 5.42546 15.7083 5.59722 15.5528 5.75278L5.30556 16H2ZM11.7028 6.29722L11.1583 5.73333L12.2667 6.84167L11.7028 6.29722Z",
    fill: " currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/EditIcon.8680c9ef886f90d4bd1df0423db6c8b3.svg";
export { ForwardRef as ReactComponent };